import { configureStore, createListenerMiddleware, isAnyOf } from "@reduxjs/toolkit";
import sessionReducer, {
  loginUser,
  logout,
  refreshLogin,
} from "@/features/auth/store/sessionSlice";

// Listener middleware to get the user after login or refresh
const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(loginUser.rejected, refreshLogin.rejected),
  effect: async (_action, listenerApi) => {
    listenerApi.dispatch(logout());
  },
});

export const store = configureStore({
  reducer: { session: sessionReducer },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
